import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { commandPermissions } from './command-permissions';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UnblockCommand {}

const client = createClient('/rest/operator-api/charging-stations');

export const unblock: SaveOperation<UnblockCommand, void, string> = postRequestFactory<UnblockCommand, void, string>(
  client,
  {
    pattern: '/{chargingStationId}/unblock',
    permissionId: commandPermissions.UNBLOCK_CHARGING_STATION
  }
);
